import type { AiBusinessCenterModule } from '../types'

/** 招标管理独立应用配置。 */
export const tenderModule: AiBusinessCenterModule = {
  key: 'tender',
  label: '招标管理',
  desc: '招标计划/项目/公告/文件/投标/开标/评标/定标/专家库',
  path: '/tender',
  homePath: '/tender/plan',
  icon: 'ep:trophy',
  color: '#f59e0b'
}
